// PARWIN 30 Oct 2026 (Davide: desktop menu closes when moving into the dropdown).
// Horizon's header menu closes the open dropdown the instant the pointer leaves its top-level item or touches another one
// (e.g. moving diagonally from "Hair tools" to the dropdown's left column crosses "Bestsellers"). This adds hover intent:
// while a dropdown is open, leaving its item or entering a sibling only takes effect if the pointer is still there after
// a short pause. Reaching the dropdown cancels it. Desktop mouse only; keyboard, touch and mobile menus are untouched.
(function () {
  if (window.__ppMenuIntent) return; window.__ppMenuIntent = true;
  var mq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!mq || !mq.matches) return;
  var ENTER_MS = 180, LEAVE_MS = 260, FLAG = '__ppIntent';
  var enterTimer = null, leaveTimer = null, py = 0, pyAt = 0;
  // pointer heading down (towards the open dropdown) in the last moments: keep the dropdown, don't switch yet
  document.addEventListener('pointermove', function (e) { py = e.clientY; pyAt = Date.now(); }, { passive: true, capture: true });
  function headingDown(y0) { return py - y0 > 2 && Date.now() - pyAt < 120; }
  function openItem() {
    var link = document.querySelector('.menu-list__list-item > .menu-list__link[aria-haspopup][aria-expanded="true"]');
    return link ? link.parentElement : null;
  }
  function isTopItem(el) { return el instanceof Element && el.matches('.menu-list__list-item') && !!el.closest('header-menu, .header-menu'); }
  function replay(el, type) { var e = new PointerEvent(type, { bubbles: false }); e[FLAG] = true; el.dispatchEvent(e); }
  document.addEventListener('pointerenter', function (e) {
    var li = e.target; if (e[FLAG] || !isTopItem(li)) return;
    var open = openItem();
    if (!open || open === li) { clearTimeout(leaveTimer); return; }
    e.stopImmediatePropagation();
    clearTimeout(enterTimer);
    (function wait(y0) {
      enterTimer = setTimeout(function () {
        if (!li.matches(':hover') || openItem() !== open || open.matches(':hover')) return;
        if (headingDown(y0)) return wait(py);
        clearTimeout(leaveTimer); replay(li, 'pointerenter');
      }, ENTER_MS);
    })(py);
  }, true);
  document.addEventListener('pointerleave', function (e) {
    var li = e.target; if (e[FLAG] || !isTopItem(li)) return;
    if (li !== openItem()) return;
    e.stopImmediatePropagation();
    clearTimeout(leaveTimer);
    (function wait(y0) { leaveTimer = setTimeout(function () {
      if (li.matches(':hover') || openItem() !== li) return;
      if (headingDown(y0)) return wait(py);
      var other = Array.prototype.find.call(document.querySelectorAll('.menu-list__list-item'), function (x) { return x !== li && x.matches(':hover'); });
      replay(li, 'pointerleave');
      if (other) replay(other, 'pointerenter');
    }, LEAVE_MS); })(py);
  }, true);
})();
